import { IEnquiryFlight } from '@simplyfly/shared';
import {
  EnumFlightChecklistTemplateFieldType,
  IFlightChecklistTemplate,
  IFlightChecklistTemplateField
} from '@simplyfly/shared';
import { IFlightChecklist, IFlightChecklistFieldDataValue } from '@simplyfly/shared';

export const appendFlightChecklistFieldValue = (
  checklist: IFlightChecklist,
  field: IFlightChecklistTemplateField,
  value: IFlightChecklistFieldDataValue
): IFlightChecklist => {
  const existing = checklist.fieldData.find(item => item.fieldId === field.id);

  return {
    ...checklist,
    fieldData: existing
      ? checklist.fieldData.map(item =>
          item.fieldId === field.id ? { ...item, history: [...item.history, value] } : item
        )
      : [
          ...checklist.fieldData,
          {
            fieldId: field.id,
            text: field.text,
            defaultOptionId: field.defaultOptionId ?? null,
            finalOptionId: field.finalOptionId ?? null,
            history: [value]
          }
        ]
  };
};

export const initFlightChecklistFromTemplate = (
  enquiryFlight: IEnquiryFlight,
  flightChecklistTemplate: IFlightChecklistTemplate
): IFlightChecklist => {
  const flightChecklist: IFlightChecklist = {
    enquiryFlightId: enquiryFlight.id,
    enquiryId: enquiryFlight.enquiryId,
    enquiryType: enquiryFlight.enquiryType,
    fieldData: []
  } as IFlightChecklist;

  for (const module of flightChecklistTemplate.modules) {
    for (const field of module.fields) {
      flightChecklist.fieldData.push({
        fieldId: field.id,
        text: field.text,
        defaultOptionId: field.defaultOptionId ?? null,
        finalOptionId: field.finalOptionId ?? null,
        history: []
      });
    }
  }

  return flightChecklist;
};

export const getFinishedCheckOnTotalForFlight = (
  flightChecklistTemplate: IFlightChecklistTemplate,
  flightChecklist: IFlightChecklist | null
): string => {
  const total: number = getTotalCheckForFlight(flightChecklistTemplate);
  const countFinished: number = getFinishedCheckForFlight(flightChecklistTemplate, flightChecklist);

  return total > 0 ? countFinished + '/' + total : '';
};

export const getTotalCheckForFlight = (
  flightChecklistTemplate: IFlightChecklistTemplate
): number => {
  let count = 0;

  for (const module of flightChecklistTemplate.modules) {
    for (const field of module.fields) {
      if (field.type === EnumFlightChecklistTemplateFieldType.select) {
        count++;
      }
    }
  }

  return count;
};

export const getFinishedCheckForFlight = (
  flightChecklistTemplate: IFlightChecklistTemplate,
  flightChecklist: IFlightChecklist | null
): number => {
  let count = 0;

  const flightChecklistFieldValues: { [fieldId: string]: string | null } = {};

  if (flightChecklist) {
    for (const fieldData of flightChecklist.fieldData) {
      if (fieldData.history.length) {
        flightChecklistFieldValues[fieldData.fieldId] =
          fieldData.history[fieldData.history.length - 1].value;
      } else {
        flightChecklistFieldValues[fieldData.fieldId] = fieldData.defaultOptionId;
      }
    }
  }

  for (const module of flightChecklistTemplate.modules) {
    for (const field of module.fields) {
      if (
        field.type === EnumFlightChecklistTemplateFieldType.select &&
        field.finalOptionId &&
        typeof flightChecklistFieldValues[field.id] !== 'undefined' &&
        flightChecklistFieldValues[field.id] === field.finalOptionId
      ) {
        count++;
      }
    }
  }

  return count;
};
